module.exports = __webpack_public_path__ + "img/6.0dd58850.png";